export default "__VITE_ASSET__DSphRUmp__"